/*
 * Special View for handling the report group and report pages, and switching between them without distroying each other
 * Uses the same switching logic as our topic splitter.
 */

define(["marionette", "jquery", "modules/reportSplit/template/reportSplitTemplate.html"], function (
  Marionette,
  $,
  ReportSplitTemplate,
) {
  var ReportSplitView = {};

  ReportSplitView.reportSplitLayout = Marionette.Layout.extend({
    template: ReportSplitTemplate,
    regions: {
      groupsRegion: "#groupsRegion",
      reportRegion: "#reportRegion",
      adHocReportRegion: "#adHocReportRegion",
    },
    hideReport: function () {
      $("#reportRegion").hide();
    },
    hideAdHocReport: function () {
      $("#adHocReportRegion").hide();
    },
    hideGroups: function () {
      $("#groupsRegion").hide();
    },
    showReportPage: function () {
      $("#reportRegion").show();
    },
    showAdHocReport: function () {
      $("#adHocReportRegion").show();
    },
    showGroups: function () {
      $("#groupsRegion").show();
    },
  });

  return ReportSplitView;
});
